import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SettlementAccountFieldsComponent } from "./settlement-account-fields.component";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsSharedModule } from "@shared/modules/forms-shared.module";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { MatGridListModule } from "@angular/material/grid-list";
import { SettlementAccountFieldItemComponent } from "./_components/settlement-account-field-item/settlement-account-field-item.component";
import { ExpansionPanelModule } from "../expansion-panel/expansion-panel.module";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatDividerModule } from "@angular/material/divider";
import { SharedModule } from "@shared/shared.module";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";

@NgModule({
	declarations: [SettlementAccountFieldsComponent, SettlementAccountFieldItemComponent],
	imports: [
		CommonModule,
		FormsSharedModule,
		ReactiveFormsModule,
		MatIconModule,
		MatCardModule,
		MatGridListModule,
		MatButtonModule,
		MatSlideToggleModule,
		ExpansionPanelModule,
		MatTooltipModule,
		FlexLayoutModule,
		MatDividerModule,
		ReactiveFormsModule,
		SharedModule,
		MatCheckboxModule
	],
	exports: [SettlementAccountFieldsComponent]
})
export class SettlementAccountFieldsModule {}
